import { AlarmIcon, EditIcon } from '../../Icons'
import '../index.css'

interface EditChipProps {
  onClick?: () => void
  label?: string
}

const EditChip: React.FC<EditChipProps> = ({ onClick, label }) => {

  return (
    <div>
      <button className="chip-btn" onClick={onClick}>
        <EditIcon className="chip-btn__icon" />
        {label}
      </button>
    </div>
  )
}

const EditAlarm: React.FC<EditChipProps> = ({ onClick, label }) => {

  return (
    <div>
      <button className="chip-btn" onClick={onClick}>
        <AlarmIcon className="chip-btn__icon" />
        {label}
      </button>
    </div>
  )
}

export default EditChip;
export { EditAlarm }